import { render, staticRenderFns } from "./AutoTaggingUrl.vue?vue&type=template&id=b20c6a90&scoped=true&"
import script from "./AutoTaggingUrl.vue?vue&type=script&setup=true&lang=js&"
export * from "./AutoTaggingUrl.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20c6a90",
  null
  
)

export default component.exports